/**
 * Admin favorite publishers. `is_favorite` comes from the API (raw SQL rows carry 0/1). The API
 * already returns favorites first, by name; this tier keeps that order wherever the panel re-sorts
 * rows on the client.
 */
export function compareFavoriteFirst(isFavoriteA, isFavoriteB) {
	return Number(!!isFavoriteB) - Number(!!isFavoriteA);
}
